import {useTranslation} from 'react-i18next';
import {INav} from 'features/layout/redux/helpers/FoldersHelper';
import {each, union, without} from 'lodash';
import {BaseFolderProps} from 'features/layout/SideNav/ContextItems/folders/BaseFolder';
import MenuItem from 'components/ContextMenu/MenuItem';
import React from 'react';
import {useTreeExpandCollapseContext} from 'components/ContextMenu/hooks/useTreeExpandCollapseContext';

const ExpandCollapse = ({data}: Pick<BaseFolderProps, 'data'>) => {
   const {t} = useTranslation();
   const {expanded, setExpanded} = useTreeExpandCollapseContext();
   const handleExpandAll = () => {
      const ids = [] as string[];
      populateWithChildIds(ids, data);
      setExpanded(union(expanded, ids));
   };
   const handleCollapseAll = () => {
      const ids = [] as string[];
      populateWithChildIds(ids, data);
      setExpanded(without(expanded, ...ids));
   };
   return (
      <>
         <MenuItem name={t('Expand All')} onClick={handleExpandAll} />
         <MenuItem name={t('Collapse All')} onClick={handleCollapseAll} />
      </>
   );
};

function populateWithChildIds(ids: string[], data: INav) {
   const hasChildren = (data: INav) => data.child && data.child.length > 0;
   if (hasChildren(data)) {
      ids.push(data.id);
      each(data.child, (item) => {
         if (hasChildren(item)) {
            ids.push(item.id);
            populateWithChildIds(ids, item);
         }
      });
   }
}

export default ExpandCollapse;
